import { useFeatureFlags } from 'hooks/useFeatureFlags'
import {
  DateRangePickerField,
  InputSelectControlField
} from '@sequencehq/core-components'
import { formatISODate } from '@sequencehq/utils'
import { CREDIT_NOTE_REVENUE_RECOGNITION_METHODS } from 'CreditNotes/constants'
import { CreditNoteRevenueRecognitionMethod } from 'CreditNotes/types'

export type RevRecFormValues = {
  servicePeriod: { start: string; endInclusive: string } | undefined
  revenueRecognitionMethod: CreditNoteRevenueRecognitionMethod | undefined
}

const REVENUE_RECOGNITION_METHOD_OPTIONS = Object.entries(
  CREDIT_NOTE_REVENUE_RECOGNITION_METHODS
).map(([key, value]) => ({
  label: value,
  value: key
}))

type ValidationError = { message: string }

export const ServicePeriodField = ({
  servicePeriod,
  onChange,
  validationErrors
}: {
  servicePeriod: RevRecFormValues['servicePeriod']
  onChange: (value: RevRecFormValues['servicePeriod']) => void
  validationErrors?: ValidationError[]
}) => {
  const flags = useFeatureFlags()

  if (!flags.useRevRec) return null

  return (
    <DateRangePickerField
      label="Service period"
      data-testid="creditNoteLineItemDrawer.servicePeriod"
      withOptions={false}
      value={
        servicePeriod
          ? [
              new Date(servicePeriod.start),
              new Date(servicePeriod.endInclusive)
            ]
          : undefined
      }
      onChange={([start, endInclusive]) =>
        onChange({
          start: formatISODate(start),
          endInclusive: formatISODate(endInclusive)
        })
      }
      validationErrors={validationErrors}
    />
  )
}

export const RevenueRecognitionMethodField = ({
  revenueRecognitionMethod,
  onChange,
  validationErrors
}: {
  revenueRecognitionMethod: RevRecFormValues['revenueRecognitionMethod']
  onChange: (value: RevRecFormValues['revenueRecognitionMethod']) => void
  validationErrors?: ValidationError[]
}) => {
  const flags = useFeatureFlags()

  if (!flags.useRevRec) return null

  return (
    <InputSelectControlField
      label="Revenue recognition method"
      data-testid="creditNoteLineItemDrawer.revenueRecognitionMethod"
      options={REVENUE_RECOGNITION_METHOD_OPTIONS}
      filterable={false}
      placeholder="Select recognition method"
      initialValue={revenueRecognitionMethod}
      onChange={newValue =>
        onChange(newValue as CreditNoteRevenueRecognitionMethod)
      }
      validationErrors={validationErrors}
    />
  )
}
